import { render, staticRenderFns } from "./SquareTag.vue?vue&type=template&id=09610b9c&"
import script from "./SquareTag.vue?vue&type=script&lang=ts&"
export * from "./SquareTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports